// Active-subscription Query (Query-owned server-state per STATE_POLICY)
export {
  useActiveSubscription,
  getActiveSubscriptionSnapshot,
  useSubscriptionNotificationsStore,
} from './model';
export type {
  ActiveSubscriptionData,
  EffectivePlan,
  Usage,
  SubscriptionNotification,
  SubscriptionLimits,
} from './model';

// Selector exports
export {
  useSubscription,
  usePlan,
  useUsage,
  useIsGuestMode,
  useEffectivePlan,
  useTokenBalance,
  useTokenBalanceInitialized,
  useSubscriptionLoading,
  useSubscriptionError,
  useSubscriptionNotifications,
  useIsDataLoaded,
  useRemainingTokens,
  useSubscriptionLimits,
  useSubscriptionStatus,
  useSubscriptionActions,
  useHasFeature,
  useIsSubscriptionActive,
  useCheckLimit,
  useNeedsUpgrade,
  usePlanTier,
  useProjectFeatures,
} from './model';
export type { ProjectFeatures } from './model';

// UI exports
export { PackUsageNotice } from './ui/PackUsageNotice';
export { GenerationUsageMeter } from './ui/GenerationUsageMeter';
export { ProBadge } from './ui/ProBadge';
export { SubscriptionGate } from './ui/SubscriptionGate';
export { default as SubscriptionNotifications } from './ui/SubscriptionNotifications';

export { UpgradePrompt } from './ui/UpgradePrompt';

// Lib exports
export { WEB_NATIVE_PROVIDERS, isWebNativeProvider } from './lib/provider-helpers';

// API exports
export { subscriptionService } from './api/subscriptions';
